import React, { useEffect, useState, useCallback, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { message } from 'antd';

import Button from '../Button/Button';
import ApkButton from '../Button/Button';
import styles from './LineCardUpdate.module.less';
import { CONTEXT } from '../../config';
import { logPostInfo, logging } from '../../actions/log';
import { PCStoreJsBridge } from '../../nativeapi';
import { getLocalSoft } from '../../actions/native';
import { getSearchRecommend } from '../../actions/search';
import Toast from '../../components/Toast/Toast';
import dayjs from 'dayjs';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo, checkedInfo, changeCheckbox }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const [checked, setChecked] = useState(checkedInfo[soft.softID]);
  // const [showMoreInfo, setShowMoreInfo] = useState(false);
  /**
   * 初始化处理
   */
  useEffect(() => {
    message.config({ top: 318, duration: 2.8 });
  }, []);

  const handleChange = () => {
    setChecked(!checked);
    changeCheckbox(soft.softID, !checked);
  };

  const handleIgnore = useCallback(
    softInfo => {
      PCStoreJsBridge.ignoreSoftUpdate(softInfo, !softInfo.bIgnore).then(ret => {
        if (ret.code === 0) {
          Toast.error({
            content: `${!softInfo.bIgnore ? '' : '取消'}忽略此版本升级，设置成功！`,
          });
          dispatch(getLocalSoft());
        } else {
          Toast.error({
            content: `${!softInfo.bIgnore ? '' : '取消'}忽略此版本升级，设置失败，请重试！`,
          });
        }
      });

      // 更新页面 点击全部升级 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Update_Ignore',
          label: '',
          param2: {
            source: 'Update',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: softInfo.androidType === '1' ? softInfo.packageName : softInfo.softID,
            softtype: softInfo.androidType === '1' ? 1 : 0,
            version: softInfo.version,
          },
        }),
      );
    },
    [dispatch, logging, soft],
  );

  const handleShowMoreInfo = () => {
    // 点击版本信息
    dispatch(
      logging({
        category: 'C',
        action: 'Update_New_Edition',
        label: '',
        param2: {
          source: 'Update',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: soft.androidType === '1' ? soft.packageName : soft.softID,
          softtype: soft.androidType === '1' ? 1 : 0,
          version: soft.version,
        },
      }),
    );
  };

  const handleSoftCard = useCallback(() => {
    dispatch(
      logPostInfo({
        source_p: 'Update',
        source_pp: logInfoData.source_p,
      }),
    );
  }, [dispatch]);

  const handleSoftBtn = useCallback(
    _soft => () => {
      const softInfo = _soft.androidType === '1' ? _soft.packageName : _soft.softID;
      if (softInfo) {
        dispatch(
          getSearchRecommend({
            softInfo,
            androidType: softInfo.androidType || 0,
            source: logInfo.source || 'Update',
          }),
        );
      }
    },
    [dispatch],
  );

  if (checked !== checkedInfo[soft.softID]) setChecked(checkedInfo[soft.softID]);

  return (
    <div className={styles.linecard} key={soft.softID}>
      <div className={styles.linecard_line}>
        <div className={styles.linecard_checkbox} onClick={handleChange}>
          {checked === true ? (
            <div className={styles.nopopChange} />
          ) : (
            <div className={styles.nopop} />
          )}
        </div>
        <Link
          className={styles.linecard_logo}
          to={
            soft.androidType !== '1'
              ? `${CONTEXT}/detail/soft/${soft.softID || ''}/{}`
              : `${CONTEXT}/adetail/${soft.packageName || ''}/${soft.versionCode}/${soft.bizInfo ||
                  '{}'}`
          }
          onClick={() => {
            handleSoftCard(soft);
          }}
        >
          <img className={styles.linecard_img} src={soft.logoFile} alt="" />
          {soft.androidType === '1' && <div className={styles.linecard_img_alogo} />}
        </Link>
        <div className={styles.linecard_info}>
          <Link
            to={
              soft.androidType !== '1'
                ? `${CONTEXT}/detail/soft/${soft.softID || ''}/{}`
                : `${CONTEXT}/adetail/${soft.packageName || ''}/${
                    soft.versionCode
                  }/${soft.bizInfo || '{}'}`
            }
            onClick={() => {
              handleSoftCard(soft);
            }}
          >
            <div className={styles.linecard_info_name} title={soft.softName}>
              {soft.softName}
            </div>
          </Link>
          <Link
            to={
              soft.androidType !== '1'
                ? `${CONTEXT}/detail/soft/${soft.softID || ''}/{}`
                : `${CONTEXT}/adetail/${soft.packageName || ''}/${
                    soft.versionCode
                  }/${soft.bizInfo || '{}'}`
            }
          >
            <div
              className={styles.linecard_info_desc}
              title={soft.introduction || soft.whatsNew}
              dangerouslySetInnerHTML={{ __html: soft.introduction || soft.whatsNew }}
            />
          </Link>
        </div>
        <Link
          to={
            soft.androidType !== '1'
              ? `${CONTEXT}/detail/soft/${soft.softID || ''}/{}`
              : `${CONTEXT}/adetail/${soft.packageName || ''}/${soft.versionCode}/${soft.bizInfo ||
                  '{}'}`
          }
        >
          <div className={styles.linecard_size}>{soft.installFileSize}</div>
        </Link>
        <Link
          to={
            soft.androidType !== '1'
              ? `${CONTEXT}/detail/soft/${soft.softID || ''}/{}`
              : `${CONTEXT}/adetail/${soft.packageName || ''}/${soft.versionCode}/${soft.bizInfo ||
                  '{}'}`
          }
        >
          <div className={styles.linecard_publish}>
            {soft.lastModTime ? `${dayjs(soft.lastModTime).format('YYYY-MM-DD')} 更新` : ''}
          </div>
        </Link>

        <div className={styles.linecard_version}>
          {/* <div
            className={styles.linecard_version_info}
            onClick={handleChange}
            title={soft.whatsNew || ''}
            onMouseOver={handleShowMoreInfo}
          >
            最新版本：{soft.version}
          </div> */}
          <Link
            className={styles.linecard_version_info}
            to={
              soft.androidType !== '1'
                ? `${CONTEXT}/detail/soft/${soft.softID || ''}/{}`
                : `${CONTEXT}/adetail/${soft.packageName || ''}/${
                    soft.versionCode
                  }/${soft.bizInfo || '{}'}`
            }
            title={soft.whatsNew || ''}
            onMouseOver={handleShowMoreInfo}
            onClick={() => {
              handleSoftCard(soft);
            }}
          >
            最新版本：{soft.version}
          </Link>
        </div>
        <div
          className={styles.linecard_ignore}
          onClick={() => {
            handleIgnore(soft);
          }}
        >
          忽略
        </div>

        <div className={styles.linecard_btn_box} onClick={handleSoftBtn(soft)}>
          {soft.androidType !== '1' ? (
            <Button
              soft={soft}
              info={{
                className: styles.soft_btn,
                className_busing: styles.soft_btn_b,
                className_open: styles.soft_button_open,
                text: '升级',
              }}
              logInfo={logInfo}
            />
          ) : (
            <ApkButton
              soft={soft}
              info={{
                className: styles.soft_btn,
                className_busing: styles.soft_btn_b,
                className_open: styles.soft_button_open,
                text: '升级',
              }}
              logInfo={logInfo}
            />
          )}
        </div>
      </div>

      {/* {showMoreInfo && soft.whatsNew && (
        <div className={styles.linecard_whatnew}>
          <div title={soft.whatsNew || ''}>新版功能：</div>
          <div
            className={styles.linecard_whatnew_info}
            dangerouslySetInnerHTML={{
              __html: soft.whatsNew.split('\n').join('<br/>'),
            }}
          ></div>
        </div>
      )} */}
    </div>
  );
});
